export const HOME_CRUMB = { title: "Home", path: "/" };
export const SUBJECT_DETAIL_CRUMB = { title: "Subjects", path: "/subjects/" };
export const SERIES_CRUMB = { title: "Series", path: "/series/" };
export const AUTHOR_CRUMB = { title: "Authors", path: "/authors/" };
export const BLOG_CRUMB = { title: "Blog", path: "/blog/" };
export const NEWS_CRUMB = { title: "News", path: "/news/" };
export const EVENT_CRUMB = { title: "Events", path: "/events/" };
